import { escapeRegExp, isEmpty } from "lodash";
import { type ReactNode } from "react";

interface ReplaceRule {
    match: string | RegExp;
    render: (match: string) => ReactNode;
}

export const replaceWithComponents = (
    text: string,
    rules: ReplaceRule[]
): ReactNode[] => {
    if (isEmpty(rules)) return [text];

    const pattern = rules
        .map((rule) =>
            typeof rule.match === "string"
                ? `(?<!\\w)${escapeRegExp(rule.match)}(?!\\w)`
                : rule.match.source
        )
        .join("|");

    const regex = new RegExp(`(${pattern})`, "g");

    return text.split(regex).map((part) => {
        const rule = rules.find((r) =>
            typeof r.match === "string"
                ? r.match === part
                : new RegExp(
                      `^(?:${r.match.source})$`,
                      r.match.flags.replace("g", "")
                  ).test(part)
        );
        return rule ? rule.render(part) : part;
    });
};
